import React from "react";

import "./styles.css";

interface MediaLoadingIndicatorProps {
  className?: string;
  label: string;
}

const MediaLoadingIndicator = ({
  className = "",
  label,
}: MediaLoadingIndicatorProps) => (
  <div
    className={`media-loading-indicator${className ? ` ${className}` : ""}`}
    role="progressbar"
    aria-label={label}
    aria-live="polite"
    aria-valuetext={label}
  >
    <span className="media-loading-indicator__spinner" aria-hidden="true" />
    <span className="media-loading-indicator__label" aria-hidden="true">
      {label}
    </span>
  </div>
);

export default MediaLoadingIndicator;
